/* [DV-ROZET-KART 2026-08-05] Koleksiyon + arama kartlarinda durum rozeti.
   Veri: dv-rozet-data.js (window.__DV_ROZET__.urun — sunucuda dvRozet.js uretir;
   fiyat gecmisi + aktif kampanya + TUM KANAL gercek satislarindan hesaplanir).
   GERCEKLIK: veri 48 saatten eskiyse HICBIR rozet gosterilmez (fail-closed).
   ONCELIK: Liquid'in bastigi kitlik rozeti ("Son X Adet") varsa JS rozet basmaz.
   Kart basina en fazla 1 durum rozeti (sol ust) + mevcut indirim rozeti (sag ust).
   Fiyata, sepete, kampanya motoruna DOKUNMAZ — salt gorsel katman. */
(function () {
  'use strict';
  if (window.__DV_ROZET_KART__) return;
  window.__DV_ROZET_KART__ = true;

  var BAYAT_MS = 48 * 60 * 60 * 1000;

  var METIN = {
    sup: 'Süper Avantajlı',
    avn: 'Avantajlı Ürün',
    end7: 'Son 7 Günün En Düşüğü',
    end14: 'Son 14 Günün En Düşüğü',
    end30: 'Son 30 Günün En Düşüğü',
    cs: 'Çok Satan'
  };
  var SINIF = {
    sup: 'dv-kr-sup', avn: 'dv-kr-avn',
    end7: 'dv-kr-end', end14: 'dv-kr-end', end30: 'dv-kr-end',
    cs: 'dv-kr-cs'
  };
  var IPUCU = {
    sup: 'Aktif kampanya indirimi %30 ve üzeri; fiyat, kayıtlı fiyat geçmişimizdeki en düşük seviyede.',
    avn: 'Aktif kampanya indirimi %15 ve üzeri.',
    end7: 'Kayıtlı fiyat geçmişimize göre en düşük fiyatlı ölçü, son 7 günün en düşüğünde.',
    end14: 'Kayıtlı fiyat geçmişimize göre en düşük fiyatlı ölçü, son 14 günün en düşüğünde.',
    end30: 'Kayıtlı fiyat geçmişimize göre en düşük fiyatlı ölçü, son 30 günün en düşüğünde.'
  };

  function stilEkle() {
    if (document.getElementById('dv-rozet-kart-stil')) return;
    var s = document.createElement('style');
    s.id = 'dv-rozet-kart-stil';
    s.textContent =
      '.dv-kart-rozet{position:absolute;top:10px;left:10px;z-index:12;font-size:12px;font-weight:600;' +
      'line-height:1;padding:4px 8px;border-radius:6px;pointer-events:none;white-space:nowrap;' +
      'max-width:calc(100% - 20px);overflow:hidden;text-overflow:ellipsis;letter-spacing:.2px}' +
      '.dv-kr-sup{background:#d74800;color:#fff}' +
      '.dv-kr-avn{background:#fff;color:#d74800;border:1px solid #d74800}' +
      '.dv-kr-end{background:#1a7f37;color:#fff}' +
      '.dv-kr-cs{background:#1f2937;color:#fff}' +
      '@media (max-width:767px){.dv-kart-rozet,.dv-kitlik-rozet{font-size:11px !important;padding:3px 6px !important;top:8px !important;left:8px !important}}' +
      /* sol ust durum rozetine ayrildi; karttaki indirim yuzdesi sag uste */
      '.hdt-card-product .dolcevita-discount-badge{left:auto !important;right:10px !important;top:10px !important}' +
      /* [CAKISMA-FIX] Ozel Olcu rozeti sag ustte sabit; indirim onunla cakismasin diye altina iner */
      '.hdt-card-product:has(.hdt-badge__custom) .dolcevita-discount-badge{top:56px !important;right:10px !important;left:auto !important}';
    document.head.appendChild(s);
  }

  function veri() {
    var d = window.__DV_ROZET__;
    if (!d || !d.urun) return null;
    var g = Date.parse(d.gen || '');
    if (!isFinite(g) || Date.now() - g > BAYAT_MS) return null; // fail-closed
    return d.urun;
  }

  function rozetSec(u) {
    if (u.r && u.r.length && METIN[u.r[0]]) return u.r[0];
    if (u.cs) return 'cs';
    return null;
  }

  function uygula(kok) {
    var U = veri();
    if (!U) return;
    var kartlar = (kok && kok.querySelectorAll ? kok : document).querySelectorAll('.hdt-card-product');
    for (var i = 0; i < kartlar.length; i++) {
      var k = kartlar[i];
      if (k.__dvKR) continue;
      k.__dvKR = true;
      if (k.querySelector('.dv-kitlik-rozet')) continue; // kitlik ustun (gercek stok)
      var idEl = k.querySelector('[data-flair-product-badge][data-product-id]');
      var pid = idEl && idEl.getAttribute('data-product-id');
      if (!pid) continue;
      var u = U[String(pid).trim()];
      if (!u) continue;
      var tip = rozetSec(u);
      if (!tip) continue;
      var med = k.querySelector('.hdt-card-product__media');
      if (!med) continue;
      var s = document.createElement('span');
      s.className = 'dv-kart-rozet ' + SINIF[tip];
      s.textContent = METIN[tip];
      if (tip === 'cs' && u.cs) s.title = 'Son 30 günde ' + u.cs + ' adet satıldı (tüm satış kanalları toplamı)';
      else if (IPUCU[tip]) s.title = IPUCU[tip];
      med.appendChild(s);
    }
  }

  var moZamanlayici = null;
  function basla() {
    stilEkle();
    uygula(document);
    // sonsuz kaydirma / filtre yeniden cizimleri
    try {
      var mo = new MutationObserver(function () {
        if (moZamanlayici) return;
        moZamanlayici = setTimeout(function () { moZamanlayici = null; uygula(document); }, 250);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* eski tarayici: ilk cizim yeterli */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();

/* [DV-INDIRIM-SOZLESME 2026-08-26] Kart yuzdesi TEK SOZLESMEDEN.
   Liquid sunucuda liste-referansli orani basar; burada yasal referans (indirim oncesi
   30 gunun en dusugu) varsa oran ona gore YENIDEN yazilir — urun detayla ayni sayi. */
(function () {
  'use strict';
  function duzelt() {
    if (!window.DVIndirim || typeof window.DVIndirim.referansKurus !== 'function') return;
    var rozetler = document.querySelectorAll('.dolcevita-discount-badge[data-dv-campaign-variant]');
    for (var i = 0; i < rozetler.length; i++) {
      var el = rozetler[i];
      if (el.dataset.dvRefUygulandi === '1') continue;
      var vid = el.getAttribute('data-dv-campaign-variant');
      var satis = Number(el.getAttribute('data-sale-cents'));
      var ref = window.DVIndirim.referansKurus(vid);
      if (!ref) { var bo = Number(el.getAttribute('data-base-cents')); if (bo > 0) ref = bo; }
      if (!(satis > 0)) continue;
      if (!ref) { el.dataset.dvRefUygulandi = '1'; el.remove(); continue; }  // olculebilir referans yok -> iddia yok
      var oran = window.DVIndirim.yuzde(ref, satis);
      el.dataset.dvRefUygulandi = '1';
      if (!(oran >= 1)) { el.remove(); continue; }   // referansa gore indirim yok -> rozet iddia edilmez
      el.setAttribute('data-percent', String(oran));
      var yuzdeSpan = el.querySelector('span');
      if (yuzdeSpan) yuzdeSpan.textContent = oran + '%';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', duzelt);
  else duzelt();
  window.setTimeout(duzelt, 600);
  window.setTimeout(duzelt, 1800);
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { duzelt(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
